"use client";
import React, { useState, useEffect } from "react";
import Autocomplete from "./Autocomplete";
import { useUser } from "../hooks/query";

interface User {
    Id: string;
    FirstName: string;
    LastName: string;
    Email: string;
}

interface UserSelectorProps {
    name: string;
    label: string;
    placeholder?: string;
    rules?: any;
    helperText?: string;
    size?: "sm" | "md" | "lg";
    helperType?: "tooltip" | undefined;
    disabled?: boolean;
}

const UserSelector: React.FC<UserSelectorProps> = ({
    name,
    label,
    placeholder = "Select user",
    rules = {},
    helperText,
    size = "md",
    helperType,
    disabled = false,
    ...props
}) => {
    const { useList } = useUser();
    const listUsers = useList();

    const [users, setUsers] = useState<User[]>([]);
    const [loading, setLoading] = useState(false);

    // Fetch users on component mount
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                setLoading(true);
                const response = await listUsers.mutateAsync({});
                if (response && Array.isArray(response)) {
                    setUsers(response);
                }
            } catch (error) {
                console.error("Error fetching users:", error);
                setUsers([]);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    // Transform users for autocomplete
    const userOptions = users.map((user) => ({
        value: user.Id,
        label: `${user.FirstName} ${user.LastName}`,
        user: user,
    }));

    return (
        <Autocomplete
            name={name}
            label={label}
            placeholder={placeholder}
            rules={rules}
            helperText={helperText}
            size={size}
            helperType={helperType}
            options={userOptions}
            {...props}
        />
    );
};

export default UserSelector;
